import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  location: string;
}
export function TestimonialCard({
  quote,
  name,
  location
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-392">
      <div className="flex gap-1 mb-4" data-id="element-393">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-394" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-1" data-id="element-395">"{quote}"</p>
      <div className="mt-auto" data-id="element-396">
        <p className="font-bold text-[#2C3E50]" data-id="element-397">{name}</p>
        <p className="text-sm text-gray-500" data-id="element-398">{location}</p>
      </div>
    </div>;
}